export default __webpack_public_path__ + "static/media/redeem-bonus2-1.dcca5d20.webp";